<template>
  <DialogFull :data="dialogSettings" @close="close" custom-actions>
    <template v-slot:dialog.body>
      <div class="container interview-format-list col-lg-8 col-sm-12">
        <div v-if="isFetchingInterviewFormats">
          <v-skeleton-loader
            v-for="i in 5"
            :key="i"
            type="list-item-three-line"
            class="my-2"
          />
        </div>
        <div v-else>
          <InterviewFormatDetails
            v-for="(interviewFormat, index) in interviewFormats"
            :key="index"
            :interviewFormat="interviewFormat"
            class="my-5"
          />
          <BaseFooter>
            <ExpandedButtons>
              <Permissioned
                :vertical="isMobile"
                class="actions-bar"
                section="interviews.interview-formats"
              >
                <AddInterviewFormatAction permission="edit-interview-format" />
              </Permissioned>
            </ExpandedButtons>
          </BaseFooter>
        </div>
      </div>
    </template>
  </DialogFull>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import { FETCH_BOOKING_INTERVIEW_FORMATS } from "@/store/modules/bookings/interviews/actions";
import InterviewFormatDetails from "@/views/bookings/BookingInterviews/components/InterviewFormatDetails";
import { copyState } from "@/utils/helpers";
import DialogFull from "@/components/common/DialogFull";
import AddInterviewFormatAction from "@/views/bookings/BookingInterviews/components/actions/AddInterviewFormatAction";
import BaseFooter from "@/components/common/BaseFooter";
import Permissioned from "@/components/common/Permissioned";
import ExpandedButtons from "@/components/common/ExpandedButtons";

const {
  mapActions: mapInterviewActions,
  mapState: mapInterviewState
} = createNamespacedHelpers(INTERVIEWS_NAMESPACE);

export default {
  props: {
    isOpen: Boolean
  },
  components: {
    InterviewFormatDetails,
    DialogFull,
    AddInterviewFormatAction,
    BaseFooter,
    Permissioned,
    ExpandedButtons
  },
  created() {
    this.fetchInterviewFormats({
      bookingId: this.currentBookingId,
      withInclude: true
    });
  },
  data() {
    return {
      selectedInterviewFormat: null,
      showValidationErrors: false
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Interview Formats"
      };
    },
    ...mapInterviewState(
      copyState(["interviewFormats", "isFetchingInterviewFormats"])
    ),
    currentBookingId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapInterviewActions({
      fetchInterviewFormats: FETCH_BOOKING_INTERVIEW_FORMATS
    }),
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
